import { TOGGLE_MODAL, SET_SUBMITTED } from './constants';

const initialState = { visible: false, submitted: false };

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case TOGGLE_MODAL: {
      const { visible } = action.payload;
      return { ...state, visible };
    }
    case SET_SUBMITTED: {
      const { submitted } = action.payload;
      return { ...state, submitted };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/javascript/pro_platform/components/EnquireModal/reducer.js